<template>
  <div class="pie-chart">
    <h3 class="pl-4 pt-2">{{ $t(label) }}</h3>
    <apexchart type="pie" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { createWidgetMixin } from 'vue-instantsearch'
import { connectRefinementList } from 'instantsearch.js/es/connectors/'
import VueApexCharts from 'vue-apexcharts'
import algoliasearch from 'algoliasearch/lite'

export default {
  name: 'ShipmentsTypeChart',
  components: {
    'apexchart': VueApexCharts
  },
  mixins: [
    createWidgetMixin({ connector: connectRefinementList })
  ],
  props: {
    totalResults: Number,
    label: String,
    attribute: String,
    color: String,
    breakpoints: Array
  },
  data () {
    return {
      series: [],
      labels: []
    }
  },
  computed: {
    ...mapState(['generalApp']),
    results () {
      let results = []
      if (this.state !== null) {
        results = this.state.items
      }
      return results
    },
    breakpointsLabels () {
      let labels = []
      for (let i = 0; i < this.breakpoints.length; i++) {
        if (i === this.breakpoints.length - 1) {
          labels.push('>' + this.breakpoints[i])
        } else {
          if (i === 0) {
            labels.push('<' + this.breakpoints[i])
          }
          labels.push(this.breakpoints[i] + '-' + this.breakpoints[i + 1])
        }
      }
      return labels
    },
    widgetParams () {
      return {
        limit: 1000,
        attribute: this.attribute
      }
    },
    options () {
      let options = {
        chart: {
          id: 'customers-chart'
        },
        theme: {
          monochrome: {
            enabled: true,
            color: this.color,
            shadeTo: 'light',
            shadeIntensity: 0.8
          }
        },
        labels: this.labels,
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom'
            }
          }
        }],
        noData: {
          text: this.$i18n.t('reports.no_data') // TODO: change for more user friendly message
        }
      }
      return options
    },
    customersFromFilter () {
      let filteredCustomers = []
      this.generalApp.allSelectedFilters.forEach(filter => {
        if (filter.filterObj.attribute === this.attribute) {
          filteredCustomers = filter.filterObj.values
        }
      })
      return filteredCustomers
    }
  },
  watch: {
    results (value) {
      if (this.breakpoints) {
        let labels = this.breakpointsLabels
        let series = new Array(labels.length).fill(0)
        const recordLength = value.length

        for (let i = 0; i < recordLength; i++) {
          for (let j = 0; j < this.breakpoints.length; j++) {
            if (value[i].value < this.breakpoints[j]) {
              series[j] = series[j] + value[i].count
              break
            } else {
              if (j === this.breakpoints.length - 1) {
                series[j + 1] = series[j + 1] + value[i].count
              }
            }
          }
        }
        this.labels = labels
        this.series = series
      } else {
        let labels = []
        let series = []
        let totals = this.totalResults
        const recordLength = value.length
        for (let i = 0; i < recordLength; i++) {
          if (this.customersFromFilter.length === 0 || this.customersFromFilter.includes(value[i].value)) {
            if (value[i].count / this.totalResults > 0.07 || i < 6) {
              labels.push(this.$t('shipments.'+value[i].value))
              series.push(value[i].count)
              totals = totals - value[i].count
            }
          }
        }
        if (totals > 0) {
          labels.push(this.$t('shipments.others'))
          series.push(totals)
        }

        this.labels = labels
        this.series = series
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .cutomers-chart {
    border-right: 1px dotted grey;
  }
</style>
